module.exports = __webpack_public_path__ + "img/casita.e5b5963b.svg";